import axios from 'axios'
import type { InvitePreviewResponse } from '../types/UserInviteTypes'

/**
 * Fetches minimum preview information for a pending invite.
 * This is an unauthenticated endpoint — no auth token required.
 * @param token - The invite token from the email link
 * @returns Workspace name and inviter name, or null if invalid/expired
 */
export async function getInvitePreview(
  token: string,
): Promise<InvitePreviewResponse | null> {
  try {
    const response = await axios.get<InvitePreviewResponse>(
      `${import.meta.env.VITE_MOLY_API}/api/v1.0/invites/preview`,
      { params: { token } },
    )
    return response.data
  } catch {
    return null
  }
}
